<template>
	<div class="technology">
		<common-layout>
			<div slot="header">
				<div class="technology.tabs">
					<span v-for="(btn,index) in tabs" :key="index"  @click="handleClick(index)" :class="{'active_t':activeType== index}">
						{{btn.name}}
					</span>
				</div>
				<ul class="technology.nav">
					<li>内容管理</li>
					<li class="+active-Tab">信息服务</li>
				</ul>
			</div>
			<div slot="container">
				<!-- <el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="科技资讯" name="1"></el-tab-pane>
					<el-tab-pane label="资料下载" name="2"></el-tab-pane>
				</el-tabs> -->
				<div class="technology-content">
					<slot></slot>
				</div>
			</div>
		</common-layout>

	</div>
</template>

<script>
	import CommonLayout from '../../components/common-layout.vue'
	export default {
		components: {
			CommonLayout
		},
		data() {
			return {
				activeType: 0,
				tabs:[{name:'科技资讯'},{name:'资料下载'}]
			};
		},
		created() {
			if (/(case)/.test(this.$route.path)) {
				this.activeType = 0
			} else {
				this.activeType = 1
			}
		},
		methods: {
			handleClick(index) {
				if (index == 0) {
					this.$router.push("/content/technology/case");
				} else {
					this.$router.push("/content/technology/data");
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	@include component(technology){
		height: 100%;
		@include part(tabs){
			width: 300px;
			height: 50px;
			border: 1px solid #ef9f49;
			display: flex;
			border-radius: 50px;
			overflow: hidden;
			cursor: pointer;
			>span{
				display: inline-block;
				width: 150px;
				height: 50px;
				line-height: 50px;
				font-weight: bold;
				&.active_t{
					background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
					color: #fff;
				}
				
				
			}
		}
		@include part(nav){
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		@include tweak(active-Tab){
			color: rgba(255,255,255,0.4);
			&:before{
				display: inline-block;
				    padding-right: 0.5rem;
				    padding-left: 0.5rem;
				    color: rgba(255,255,255,0.4);
				    content: "/";
			}
		}
	}
</style>
